export const truncate = (str: string, length: number, excludeDots = false): string => {
  if (str.length <= length) {
    return str;
  }
  return str.substring(0, length) + (excludeDots ? '' : '...');
};
